<div class="select activator">
  <div class="select-value">
    @if ((value || value === 0) && !multiCharFractions) {
      <span class="fraction">{{ value | size }}</span>
    }
    @if ((value || value === 0) && multiCharFractions) {
      <span class="fraction">{{ value | size:'multichar' }}</span>
    }
    @if (!value && value !== 0) {
      <span class="placeholder" [innerHtml]="placeholder ? placeholder : '&nbsp;'"></span>
    }
  </div>
  <div class="select-arrow-wrapper">
    <div class="select-arrow"></div>
  </div>
</div>

@if (loaded) {
  <mbnm-size-select (onClose)="activated = false"
    #sizeSelect [range]="range" [extraOptions]="extraOptions" [(ngModel)]="value">
  </mbnm-size-select>
}
